"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.genericOutputParamSchema = exports.outputParamSchema = exports.anyOutputParamSchema = exports.floatOutputParamSchema = exports.arrayOutputParamSchema = exports.booleanOutputParamSchema = exports.integerOutputParamSchema = exports.integerArrayOutputParamSchema = exports.stringArrayOutputParamSchema = exports.fileArrayOutputParamSchema = exports.fileOutputParamSchema = exports.stringOutputParamSchema = void 0;
exports.buildOutputParamSchema = buildOutputParamSchema;
const joi_1 = __importDefault(require("joi"));
function buildOutputParamSchema(type) {
    return joi_1.default.object({
        type: joi_1.default.string().valid(type).required(),
        key: joi_1.default.string().required(),
    });
}
exports.stringOutputParamSchema = buildOutputParamSchema('STRING');
exports.fileOutputParamSchema = buildOutputParamSchema('FILE');
exports.fileArrayOutputParamSchema = buildOutputParamSchema('FILE_ARRAY');
exports.stringArrayOutputParamSchema = buildOutputParamSchema('STRING_ARRAY');
exports.integerArrayOutputParamSchema = buildOutputParamSchema('INT_ARRAY');
exports.integerOutputParamSchema = buildOutputParamSchema('INT');
exports.booleanOutputParamSchema = buildOutputParamSchema('BOOLEAN');
exports.arrayOutputParamSchema = buildOutputParamSchema('ARRAY');
exports.floatOutputParamSchema = buildOutputParamSchema('FLOAT');
exports.anyOutputParamSchema = buildOutputParamSchema('ANY');
exports.outputParamSchema = {
    STRING: exports.stringOutputParamSchema,
    FILE: exports.fileOutputParamSchema,
    FILE_ARRAY: exports.fileArrayOutputParamSchema,
    STRING_ARRAY: exports.stringArrayOutputParamSchema,
    INT_ARRAY: exports.integerArrayOutputParamSchema,
    INT: exports.integerOutputParamSchema,
    FLOAT: exports.floatOutputParamSchema,
    BOOLEAN: exports.booleanOutputParamSchema,
    ARRAY: exports.arrayOutputParamSchema,
    ANY: exports.anyOutputParamSchema,
};
/**
 * A single, composite schema that validates against any of the possible
 * input parameter types. The validated value will be typed as {@link GenericOutputParam}.
 */
exports.genericOutputParamSchema = joi_1.default.alternatives().try(exports.stringOutputParamSchema, exports.fileOutputParamSchema, exports.fileArrayOutputParamSchema, exports.stringArrayOutputParamSchema, exports.integerArrayOutputParamSchema, exports.integerOutputParamSchema, exports.floatOutputParamSchema, exports.booleanOutputParamSchema, exports.arrayOutputParamSchema, exports.floatOutputParamSchema, exports.anyOutputParamSchema);
//# sourceMappingURL=Schema.js.map